// extracted by mini-css-extract-plugin
export var chip = "_q2-2";
export var chipBody = "_q2-8";
export var chipHeader = "_q2-9";
export var chipWithKind = "_q2-7";
export var icon = "_q2-3";
export var kind = "_q2-a";
export var remove = "_q2-5";
export var removeIcon = "_q2-6";
export var row = "_q2-0";
export var rowHistorical = "_q2-1";
export var text = "_q2-4";